/* SETTINGS */
export const CHANGE_LOCALE = 'CHANGE_LOCALE';

/* FETCH */

export const FETCH_START = 'FETCH_START';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR'

/* MODALS */

export const MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW = 'MODAL_COLLABORATORS_PURCHASE_FILTER_SHOW';
export const MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE = 'MODAL_COLLABORATORS_PURCHASE_FILTER_HIDE';

/* PRODUCTS */

export const PRODUCTS_LIST = 'PRODUCTS_LIST';
export const PRODUCTS_LIST_SUCCESS = 'PRODUCTS_LIST_SUCCESS';
export const PRODUCTS_LIST_ERROR = 'PRODUCTS_LIST_ERROR';

/* PURCHASES */

export const RESET_PURCHASE = 'RESET_PURCHASE';
export const RESET_PURCHASE_SUCCESS = 'RESET_PURCHASE_SUCCESS';
export const RESET_PURCHASE_ERROR = 'RESET_PURCHASE_ERROR';

export const CREATE_PURCHASE = 'CREATE_PURCHASE';
export const CREATE_PURCHASE_SUCCESS = 'CREATE_PURCHASE_SUCCESS';
export const CREATE_PURCHASE_ERROR = 'CREATE_PURCHASE_ERROR';

export const GET_PURCHASE_SUMMARY = 'GET_PURCHASE_SUMMARY';
export const GET_PURCHASE_SUMMARY_SUCCESS = 'GET_PURCHASE_SUMMARY_SUCCESS';
export const GET_PURCHASE_SUMMARY_ERROR = 'GET_PURCHASE_SUMMARY_ERROR';

export const PAYMENT_PURCHASE = 'PAYMENT_PURCHASE';
export const PAYMENT_PURCHASE_SUCCESS = 'PAYMENT_PURCHASE_SUCCESS';
export const PAYMENT_PURCHASE_ERROR = 'PAYMENT_PURCHASE_ERROR';

export const FINISH_PURCHASE = 'FINISH_PURCHASE';
export const FINISH_PURCHASE_SUCCESS = 'FINISH_PURCHASE_SUCCESS';
export const FINISH_PURCHASE_ERROR = 'FINISH_PURCHASE_ERROR';

/* COLLABORATORS */

export const RESET_PURCHASE_COLLABORATOR = 'RESET_PURCHASE_COLLABORATOR';
export const RESET_PURCHASE_COLLABORATOR_SUCCESS = 'RESET_PURCHASE_COLLABORATOR_SUCCESS';
export const RESET_PURCHASE_COLLABORATOR_ERROR = 'RESET_PURCHASE_COLLABORATOR_ERROR';

export const COLLABORATOR_LIST = 'COLLABORATOR_LIST';
export const COLLABORATOR_LIST_SUCCESS = 'COLLABORATOR_LIST_SUCCESS';
export const COLLABORATOR_LIST_ERROR = 'COLLABORATOR_LIST_ERROR';

export const ADD_COLLABORATOR_PURCHASE = 'ADD_COLLABORATOR_PURCHASE';
export const ADD_COLLABORATOR_PURCHASE_SUCCESS = 'ADD_COLLABORATOR_PURCHASE_SUCCESS';
export const ADD_COLLABORATOR_PURCHASE_ERROR = 'ADD_COLLABORATOR_PURCHASE_ERROR';

export const COLLABORATOR_LIST_VALUES = 'COLLABORATOR_LIST_VALUES';
export const COLLABORATOR_LIST_VALUES_SUCCESS = 'COLLABORATOR_LIST_VALUES_SUCCESS';
export const COLLABORATOR_LIST_VALUES_ERROR = 'COLLABORATOR_LIST_VALUES_ERROR';

export const EDIT_COLLABORATOR_VALUE = 'EDIT_COLLABORATOR_VALUE';
export const EDIT_COLLABORATOR_VALUE_SUCCESS = 'EDIT_COLLABORATOR_VALUE_SUCCESS';
export const EDIT_COLLABORATOR_VALUE_ERROR = 'EDIT_COLLABORATOR_VALUE_ERROR';

export const UPDATE_VALUES_PURCHASE = 'UPDATE_VALUES_PURCHASE';
export const UPDATE_VALUES_PURCHASE_SUCCESS = 'UPDATE_VALUES_PURCHASE_SUCCESS';
export const UPDATE_VALUES_PURCHASE_ERROR = 'UPDATE_VALUES_PURCHASE_ERROR';

export const SUMMARY_OLD_VALUE_REBALANCE = 'SUMMARY_OLD_VALUE_REBALANCE';

/* GROUPS */

export const GROUP_LIST = 'GROUP_LIST';
export const GROUP_LIST_SUCCESS = 'GROUP_LIST_SUCCESS';
export const GROUP_LIST_ERROR = 'GROUP_LIST_ERROR';

export const PRODUCTS_GROUP = 'PRODUCTS_GROUP';
export const PRODUCTS_GROUP_SUCCESS = 'PRODUCTS_GROUP_SUCCESS';
export const PRODUCTS_GROUP_ERROR = 'PRODUCTS_GROUP_ERROR';

/* ASSIGNORS */

export const COST_CENTER_LIST = 'COST_CENTER_LIST';
export const COST_CENTER_LIST_SUCCESS = 'COST_CENTER_LIST_SUCCESS';
export const COST_CENTER_LIST_ERROR = 'COST_CENTER_LIST_ERROR';

export const DEPARTMENT_LIST = 'DEPARTMENT_LIST';
export const DEPARTMENT_LIST_SUCCESS = 'DEPARTMENT_LIST_SUCCESS';
export const DEPARTMENT_LIST_ERROR = 'DEPARTMENT_LIST_ERROR';

export const UNIT_LIST = 'UNIT_LIST';
export const UNIT_LIST_SUCCESS = 'UNIT_LIST_SUCCESS';
export const UNIT_LIST_ERROR = 'UNIT_LIST_ERROR';
